import { render } from "./levels-description.vue?vue&type=template&id=381d55ef&scoped=true&ts=true"
import script from "./levels-description.vue?vue&type=script&lang=ts"
export * from "./levels-description.vue?vue&type=script&lang=ts"

import "./levels-description.vue?vue&type=style&index=0&id=381d55ef&lang=scss&scoped=true"
import "./levels-description.vue?vue&type=style&index=1&id=381d55ef&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381d55ef"]])

export default __exports__